// 品牌插畫（空狀態 / 狀態圖）共用元件。資產由 Gemini 生成、置於 public/illustrations/
// （dark-first 線稿 + 品牌藍輝光,搭 spec 14 設計語言）。詳見 public/illustrations/README.md。
// ⚠️ 品牌藍 #3B82F6 為 placeholder（spec 14 待視覺定案）→ 定色後資產需重生。
import './illustration.css';

const ILLUSTRATIONS = {
  'no-devices': 'empty-no-devices',
  'no-events': 'empty-no-events',
  'no-recordings': 'empty-no-recordings',
  'no-shared': 'empty-no-shared',
  offline: 'state-offline',
} as const;

export type IllustrationName = keyof typeof ILLUSTRATIONS;

export function Illustration({ name, alt, size = 180 }: { name: IllustrationName; alt: string; size?: number }) {
  return (
    <img
      className="illustration"
      src={`/illustrations/${ILLUSTRATIONS[name]}.png`}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      draggable={false}
    />
  );
}
